/**
 * CardHeader — DS Molecule
 */

import styles from './CardHeader.module.css';
import { Badge } from '../../atoms';

interface CardHeaderProps {
  title: string;
  subtitle?: string;
  count?: number;
  actions?: React.ReactNode;
  className?: string;
}

export function CardHeader({ title, subtitle, count, actions, className = '' }: CardHeaderProps) {
  return (
    <div className={`${styles.header} ${className}`}>
      <div className={styles.left}>
        <div className={styles.titleRow}>
          <h3 className={styles.title}>{title}</h3>
          {count !== undefined && <Badge variant="neutral">{count}</Badge>}
        </div>
        {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
      </div>
      {actions && <div className={styles.actions}>{actions}</div>}
    </div>
  );
}
